export default __webpack_public_path__ + "images/1921bff225b30a3f6fd282b56b049733.svg";